module.exports = __webpack_public_path__ + "static/media/bottlings3.0b0d1e09.jpg";